import { Application, Controller } from "@hotwired/stimulus";

export class TabController extends Controller {
  static targets = ["tab", "content"]

  connect() {
    this.showTab(this.tabTargets[0]);
  }

  switchTab(event) {
    event.preventDefault();
    this.showTab(event.currentTarget);
  }

  showTab(tab) {
    this.tabTargets.forEach(t => t.classList.remove("active"));
    this.contentTargets.forEach(c => c.classList.remove("active"));

    tab.classList.add("active");
    const content = this.contentTargets.find(c => c.dataset.tabId === tab.dataset.tabId);
    content.classList.add("active");
  }
}

// Registered in customer.js
